module.exports = __webpack_public_path__ + "img/M99-Ring-Fight-4.53792692.jpg";